<template>
  <main class="levels bb">
    <section>
      <PageBackButton />

      <h1 class="pg_title">{{ $_translations.value.page_levels_title }}</h1>

      <h2 class="subtitle">{{ $_translations.value.page_levels_subtitle }}</h2>

      <LevelItem
        v-for="level in levelStore.levelList"
        :key="level.levelName"
        :item="level"
        @start:game="launchNewGameFlow"
        @redirect:storePage="redirectToStorePage"
      />
    </section>
  </main>

  <PreGameSection
    v-if="isPreGameVisible"
    @hide:preGame="hidePreGame"
  />
</template>

<script setup>

import PageBackButton from '@/components/button/PageBackButton.vue';
import PreGameSection from '@/components/section/PreGameSection.vue';
import LevelItem from '@/views/levels/components/LevelItem.vue';
import useLevelStore from '@/store/modules/level.js';
import usePageNavigation from '@/hooks/usePageNavigation.js';
import usePreGameHook from '@/hooks/usePreGame.js';

const levelStore = useLevelStore();

const { redirectToStorePage } = usePageNavigation();
const { isPreGameVisible, launchNewGameFlow, hidePreGame } = usePreGameHook();
</script>
